import type { RouteRecordRaw } from 'vue-router';
import { BANNER_MANAGEMENT_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const bannerManagementRoutes: RouteRecordRaw = {
  path: '/banner-management',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: BANNER_MANAGEMENT_ROUTE_NAME.BANNER_MANAGEMENT,
      path: '',
      component: () => import('./BannerManagement.vue'),
    },
  ],
};
